module.exports = __webpack_public_path__ + "media/assets/pngs/welcomeCarousel1-26eab7540931a06ee80e668c58330774.png";